import { DashboardGroup } from '@ddv/dashboards';
import { DashboardSnapshot } from '@ddv/models';

export function mapDashboardsToGroups(groups: DashboardGroup[], dashboards: DashboardSnapshot[]): DashboardGroup[] {
    return groups.map((g) => {
        const mappedDashboards: DashboardSnapshot[] = [];

        g.dashboards.forEach((d) => {
            const dashboard = dashboards.find((db) => String(db.id) === String(d.id));
            if (dashboard) {
                mappedDashboards.push(dashboard);
            }
        });
        return { ...g, dashboards: mappedDashboards };
    });
}
